import { MantineColor } from "@mantine/core";
import { useTranslation } from "react-i18next";
import type { AlertStatus } from "../../apis/return-prevention-alert";
import { DotPill, Tone } from "../delivery/atoms";

/** Kept for callers that colour charts by status. */
export const STATUS_COLOR: Record<AlertStatus, MantineColor> = {
  ACTIVE      : "orange",
  ACKNOWLEDGED: "blue",
  MUTED       : "gray",
  RESOLVED    : "green",
};

export const STATUS_VARIANT: Record<AlertStatus, "filled" | "light"> = {
  ACTIVE      : "filled",
  ACKNOWLEDGED: "light",
  MUTED       : "light",
  RESOLVED    : "light",
};

/** Dot tone (canvas Ord_Prevention «● Идэвхтэй»): waiting = amber, seen = blue, closed = green, muted = grey. */
export const STATUS_TONE: Record<AlertStatus, Tone> = {
  ACTIVE      : "amber",
  ACKNOWLEDGED: "blue",
  MUTED       : "grey",
  RESOLVED    : "green",
};

interface Props {
  status: AlertStatus;
  /** Kept for call-site compatibility; the dot pill has one size. */
  size?: "xs" | "sm" | "md" | "lg";
}

export function AlertStatusBadge({ status }: Props) {
  const { t } = useTranslation("returns");
  return <DotPill tone={STATUS_TONE[status] ?? "grey"}>{t(`alertStatus.${status}`, { defaultValue: "-" })}</DotPill>;
}
